module.exports = __webpack_public_path__ + "static/media/p26.4e770ffb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/priceless/p26.jpg
// module id = 375
// module chunks = 0